import jishikaijiang from '../../Jishikaijiang/columns/ks';
export default {
  list: Vue => {
    return jishikaijiang().list(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/ks.js